module.exports = __webpack_public_path__ + "static/media/let6.cddff123.jpg";